import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

const INITIAL_STATE = false;

const resetShouldFrontendRefresh = () => {
  shouldFrontendRefreshVar(INITIAL_STATE);
};

const shouldFrontendRefreshVar = makeFSVar(
  INITIAL_STATE,
  "shouldFrontendRefreshVar",
  resetShouldFrontendRefresh
);

const updateShouldFrontendRefresh = (newValue: boolean) => {
  shouldFrontendRefreshVar(newValue);
};

const useShouldFrontendRefresh = () => useReactiveVar(shouldFrontendRefreshVar);

export { resetShouldFrontendRefresh, updateShouldFrontendRefresh, useShouldFrontendRefresh };
